import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import AsSeenIn from "./components/AsSeenIn";
import StatsSection from "./components/StatsSection";
import AboutSection from "./components/AboutSection";
import BenefitsSection from "./components/BenefitsSection";
import EligibilitySection from "./components/EligibilitySection";
import InvestmentCTA from "./components/InvestmentCTA";
import InvestmentOptions from "./components/InvestmentOptions";
import TestimonialsSection from "./components/TestimonialsSection";
import ProcessSection from "./components/ProcessSection";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";

const HomePage = () => {
  const scrollToForm = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-white">
      <Header onContactClick={scrollToForm} />
      <main>
        <div id="hero-form">
          <HeroSection />
        </div>
        <AsSeenIn />
        <StatsSection />
        <AboutSection />
        <BenefitsSection />
        <EligibilitySection />
        <InvestmentCTA />
        <InvestmentOptions />
        <TestimonialsSection />
        <ProcessSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
